(() => {
  const productRoot = document.querySelector('[data-brine-product]');
  if (!productRoot) return;

  const select = productRoot.querySelector('[data-product-variant]');
  const image = productRoot.querySelector('[data-product-main-image]');
  const price = productRoot.querySelector('[data-product-price]');
  const button = productRoot.querySelector('[data-product-submit]');
  const thumbnails = [...productRoot.querySelectorAll('[data-product-thumbnail]')];
  const thumbnailStrip = productRoot.querySelector('[data-product-thumbnails]');
  let featuredImageSrc = image?.src || '';
  let featuredImageAlt = image?.alt || '';

  const showFeaturedImage = () => {
    if (!image || !featuredImageSrc) return;
    image.src = featuredImageSrc;
    image.alt = featuredImageAlt;
  };

  const showThumbnailImage = (thumbnail) => {
    if (!image || !thumbnail?.dataset.image) return;
    image.src = thumbnail.dataset.image;
    image.alt = thumbnail.dataset.alt || featuredImageAlt;
  };

  const updateProduct = () => {
    const option = select?.selectedOptions?.[0];
    if (!option) return;
    if (image && option.dataset.image) {
      featuredImageSrc = option.dataset.image;
      featuredImageAlt = option.dataset.title || image.alt;
      showFeaturedImage();
    }
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'ADD TO BAG ↗' : 'SOLD OUT';
    }
  };

  select?.addEventListener('change', updateProduct);
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('mouseenter', () => showThumbnailImage(thumbnail));
    thumbnail.addEventListener('focus', () => showThumbnailImage(thumbnail));
    thumbnail.addEventListener('mouseleave', showFeaturedImage);
    thumbnail.addEventListener('blur', showFeaturedImage);
  });
  thumbnailStrip?.addEventListener('mouseleave', showFeaturedImage);
  updateProduct();
})();
